import { c as _c } from "react/compiler-runtime";
import { BReviewCriteriaTypeEnum } from '@/types/backend';
import { lazy } from 'react';
const ActivityCriteriaRating = lazy(() => import('./ActivityCriteriaRating'));
const CateringCriteriaRating = lazy(() => import('./CateringCriteriaRating'));
const RatingsByCriteria = (props) => {
    const $ = _c(2);
    let t0;
    if ($[0] !== props) {
        t0 = <div className="grid grid-flow-col gap-4 xxs:gap-8">
      {props.type === BReviewCriteriaTypeEnum.Activity ?
                <ActivityCriteriaRating {...props}/> :
                <CateringCriteriaRating {...props}/>}
    </div>;
        $[0] = props;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    return t0;
};
export default RatingsByCriteria;
